import { Typography } from '@mui/material'
import { Container, Icon } from 'components/ui'
import { ObjectStrings } from 'interfaces'
import { environment, isDefined } from 'tools/common'
import { getSingletonFactorAssetByType } from 'tools/factorAssets'
import { FactorAssetInfo } from 'types/factor'
//import strings from 'l10n'

type MarketingChangelogProps = {
  styles: ObjectStrings
  hostName?: string
}

const MarketingChangelog = (props: MarketingChangelogProps) => {
  const { styles, hostName } = props

  const appVersion = process.env.REACT_APP_VERSION
  const appYear = new Date().getFullYear()
  const env = environment()
  const envTsx = env === 'PRODUCTION' ? <></> : <span>{env} - </span>
  // Solo obtener el logo cuando no esté cargando y factorId esté disponible para evitar el parpadeo
  const marketingLogo: FactorAssetInfo | undefined = getSingletonFactorAssetByType(
    'MAIN_LOGIN_SCREEN_IMAGE',
    hostName || ''
  )

  const mainLogoSection = isDefined(marketingLogo) ? (
    <div className={styles.marketingIconContainer}>
      <img src={marketingLogo.assetUrl} alt="Marketing Logo" />
    </div>
  ) : (
    <>
      <Icon boxClassName={styles.marketingIconContainer} name="icon_marketing_logo" size={250} />
      <Typography className={styles.marketingContent}>The Best Invoice Factoring Software</Typography>
    </>
  )

  return (
    <Container className={styles.marketingContainer}>
      {mainLogoSection}
      <Typography variant="caption" className={styles.betaVersion}>
        {envTsx}
        {`© ${appYear}, Version ${appVersion}`}
      </Typography>
    </Container>
  )
}

export default MarketingChangelog
